export default "__VITE_ASSET__qSeY7WWy__"